import { FC } from 'react';

import BackButton from 'components/BackButton';
import ErrorCard from 'components/ErrorCard';
import * as Layout from 'layouts/StepperLayout';

interface ErrorViewProps {
  onGoBackPressed?: () => void;
  retry?: () => void;
}

const ErrorView: FC<ErrorViewProps> = (props) => {
  const { onGoBackPressed, retry } = props;

  return (
    <Layout.Root>
      <Layout.Body>
        {onGoBackPressed ? (
          <Layout.HeaderButtonsContainer>
            <BackButton onClick={onGoBackPressed} />
          </Layout.HeaderButtonsContainer>
        ) : null}
        <Layout.BodyScrollableSection>
          <ErrorCard retry={retry} />
        </Layout.BodyScrollableSection>
      </Layout.Body>
    </Layout.Root>
  );
};

export default ErrorView;
